{
  "about.blocks": "Instâncias bloqueadas",
  "about.contact": "Contacto:",
  "about.default_locale": "Padrão",
  "about.domain_blocks.no_reason_available": "Motivo não disponível",
  "about.domain_blocks.preamble": "O Mastodon, geralmente, permite-lhe ver conteúdo e interagir com utilizadores de qualquer outro servidor na fediverso. Estas são as exceções aplicadas neste servidor em particular.",
  "about.domain_blocks.silenced.explanation": "Normalmente não verá perfis e conteúdos deste servidor, a não ser que os procures explicitamente ou opte por segui-los.",
  "about.domain_blocks.silenced.title": "Limitados",
  "about.domain_blocks.suspended.explanation": "Nenhum dado deste servidor será processado, armazenado ou trocado, impossibilitando qualquer interação ou comunicação com os utilizadores a partir deste servidor.",
  "about.domain_blocks.suspended.title": "Suspensos",
  "about.language_label": "Idioma",
  "about.not_available": "Esta informação não foi disponibilizada neste servidor.",
  "about.powered_by": "Rede social descentralizada baseada no {mastodon}",
  "about.rules": "Regras do servidor",
  "account.account_note_header": "Nota pessoal",
  "account.activity": "Atividade",
  "account.add_note": "Adicionar uma nota pessoal",
  "account.add_or_remove_from_list": "Adicionar ou remover das listas",
  "account.badges.admin": "Admin",
  "account.badges.blocked": "Bloqueado",
  "account.badges.bot": "Robô",
  "account.badges.domain_blocked": "Domínio bloqueado",
  "account.badges.group": "Grupo",
  "account.badges.muted": "Silenciado",
  "account.badges.muted_until": "Silenciado até {until}",
  "account.block": "Bloquear @{name}",
  "account.block_domain": "Bloquear domínio {domain}",
  "account.block_short": "Bloquear",
  "account.blocked": "Bloqueado/a",
  "account.cancel_follow_request": "Retirar pedido para seguir",
  "account.copy": "Copiar hiperligação para o perfil",
  "account.direct": "Enviar mensagem a @{name}",
  "account.disable_notifications": "Parar de me notificar das publicações de @{name}",
  "account.edit_note": "Editar nota pessoal",
  "account.edit_profile": "Editar perfil",
  "account.edit_profile_short": "Editar",
  "account.enable_notifications": "Notificar-me das publicações de @{name}",
  "account.endorse": "Destacar no perfil",
  "account.familiar_followers_many": "Seguido por {name1}, {name2} e {othersCount, plural,one {mais uma pessoa que conhece} other {# outras pessoas que conhece}}",
  "account.familiar_followers_one": "Seguido por {name1}",
  "account.familiar_followers_two": "Seguido por {name1} e {name2}",
  "account.featured": "Destaques",
  "account.featured.accounts": "Perfis",
  "account.featured.collections": "Coleções",
  "account.featured.new_collection": "Nova coleção",
  "account.field_overflow": "Mostrar todo o conteúdo",
  "account.filters.all": "Toda a atividade",
  "account.filters.boosts_toggle": "Mostrar partilhas",
  "account.filters.posts_boosts": "Publicações e partilhas",
  "account.filters.posts_only": "Publicações",
  "account.filters.posts_replies": "Publicações e respostas",
  "account.filters.replies_toggle": "Mostrar respostas",
  "account.follow": "Seguir",
  "account.follow_back": "Seguir também",
  "account.follow_back_short": "Seguir de volta",
  "account.follow_request": "Pedir para seguir",
  "account.follow_request_cancel": "Cancelar pedido",
  "account.follow_request_cancel_short": "Cancelar",
  "account.follow_request_short": "Pedido",
  "account.followers": "Seguidores",
  "account.followers.empty": "Ainda ninguém segue esta conta.",
  "account.followers_counter": "{count, plural, one {{counter} seguidor} other {{counter} seguidores}}",
  "account.followers_you_know_counter": "{counter} que conhece",
  "account.following": "A seguir",
  "account.following_counter": "{count, plural, one {A seguir {counter}} other {A seguir {counter}}}",
  "account.follows.empty": "Este utilizador ainda não segue ninguém.",
  "account.follows_you": "Segue-te",
  "account.go_to_profile": "Ir para o perfil",
  "account.hide_reblogs": "Esconder partilhas de @{name}",
  "account.in_memoriam": "Em Memória.",
  "account.joined": "Inscreveu-se em {date}",
  "account.joined_short": "Inscreveu-se em",
  "account.languages": "Alterar idiomas subscritos",
  "account.last_active": "Última atividade",
  "account.link_verified_on": "A posse deste link foi verificada em {date}",
  "account.locked_info": "Esta conta é privada. É preciso esperar pela autorização de quem a gere para a seguir.",
  "account.media": "Media",
  "account.mention": "Mencionar @{name}",
  "account.menu.add_to_list": "Adicionar à lista…",
  "account.menu.block": "Bloquear conta",
  "account.menu.block_domain": "Bloquear {domain}",
  "account.menu.copied": "Hiperligação para a conta copiada para área de transferência",
  "account.menu.copy": "Copiar hiperligação",
  "account.menu.direct": "Mencionar em privado",
  "account.menu.hide_reblogs": "Ocultar partilhas na cronologia",
  "account.menu.mention": "Mencionar",
  "account.menu.mute": "Silenciar conta",
  "account.menu.note.description": "Visível apenas para ti",
  "account.menu.open_original_page": "Ver em {domain}",
  "account.menu.remove_follower": "Remover seguidor",
  "account.menu.report": "Denunciar conta",
  "account.menu.share": "Partilhar…",
  "account.menu.show_reblogs": "Mostrar partilhas na cronologia",
  "account.menu.unblock": "Desbloquear conta",
  "account.menu.unblock_domain": "Desbloquear {domain}",
  "account.menu.unmute": "Desativar silenciar conta",
  "account.moved_to": "{name} indicou que a sua nova conta agora é:",
  "account.mute": "Ocultar @{name}",
  "account.mute_notifications_short": "Ocultar notificações",
  "account.mute_short": "Ocultar",
  "account.muted": "Ocultada",
  "account.mutual": "Seguem-se mutuamente",
  "account.name.copy": "Copiar identificador",
  "account.name.help.domain": "{domain} é o servidor onde estão alojados o perfil e publicações do utilizador.",
  "account.name.help.domain_self": "{domain} é o servidor que hospeda o teu perfil e publicações.",
  "account.name.help.header": "Um identificador é como um endereço de correio eletrónico",
  "account.name.help.username": "{username} é o nome de utilizador desta conta no seu servidor. Alguém pode ter o mesmo nome de utilizador noutro servidor.",
  "account.name.help.username_self": "{username} é o teu nome de utilizador neste servidor. Alguém pode ter o mesmo nome de utilizador noutro servidor.",
  "account.name_info": "O que significa isto?",
  "account.no_bio": "Nenhuma descrição fornecida.",
  "account.node_modal.callout": "As notas pessoais só são visíveis por si.",
  "account.node_modal.edit_title": "Editar nota pessoal",
  "account.node_modal.error_unknown": "Não foi possível guardar a nota",
  "account.node_modal.field_label": "Nota Pessoal",
  "account.node_modal.save": "Guardar",
  "account.node_modal.title": "Adicionar uma nota pessoal",
  "account.note.edit_button": "Editar",
  "account.note.title": "Nota pessoal (visível apenas por si)",
  "account.open_original_page": "Abrir a página original",
  "account.posts": "Publicações",
  "account.remove_from_followers": "Remover {name} dos seguidores",
  "account.report": "Denunciar @{name}",
  "account.requested_follow": "{name} pediu para te seguir",
  "account.share": "Partilhar o perfil @{name}",
  "account.show_reblogs": "Mostrar partilhas de @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} publicação} other {{counter} publicações}}",
  "account.timeline.pinned": "Fixado",
  "account.timeline.pinned.view_all": "Ver todas as publicações fixadas",
  "account.unblock": "Desbloquear @{name}",
  "account.unblock_domain": "Desbloquear o domínio {domain}",
  "account.unblock_domain_short": "Desbloquear",
  "account.unblock_short": "Desbloquear",
  "account.unendorse": "Não destacar no perfil",
  "account.unfollow": "Deixar de seguir",
  "account.unmute": "Desocultar @{name}",
  "account.unmute_notifications_short": "Desocultar notificações",
  "account.unmute_short": "Desocultar",
  "account_edit.advanced_settings.bot_hint": "Indique aos outros que a conta realiza principalmente ações automatizadas e pode não estar a ser monitorizada",
  "account_edit.advanced_settings.bot_label": "Conta automatizada",
  "account_edit.advanced_settings.title": "Definições avançadas",
  "account_edit.bio.add_label": "Adicionar biografia",
  "account_edit.bio.edit_label": "Editar biografia",
  "account_edit.bio.placeholder": "Adicione uma breve apresentação para ajudar os outros a identificá-lo.",
  "account_edit.bio.title": "Bio",
  "account_edit.bio_modal.add_title": "Adicionar biografia",
  "account_edit.bio_modal.edit_title": "Editar biografia",
  "account_edit.column_button": "Concluído",
  "account_edit.column_title": "Editar Perfil",
  "account_edit.custom_fields.add_label": "Adicionar campo",
  "account_edit.custom_fields.edit_label": "Editar campo",
  "account_edit.custom_fields.placeholder": "Adicione os seus pronomes, hiperligações externas ou qualquer outra coisa que queira partilhar.",
  "account_edit.custom_fields.reorder_button": "Reordenar campos",
  "account_edit.custom_fields.tip_content": "Pode adicionar facilmente credibilidade à sua conta Mastodon, verificando ligações para qualquer website que possua.",
  "account_edit.custom_fields.tip_title": "Dica: Adicionando links verificados",
  "account_edit.custom_fields.title": "Campos personalizados",
  "account_edit.custom_fields.verified_hint": "Como adiciono um link verificado?",
  "account_edit.display_name.add_label": "Adicionar nome a apresentar",
  "account_edit.display_name.edit_label": "Editar nome a apresentar",
  "account_edit.display_name.placeholder": "O seu nome de exibição é como o seu nome aparece no seu perfil e nas linhas do tempo.",
  "account_edit.display_name.title": "Nome a mostrar",
  "account_edit.featured_hashtags.edit_label": "Adicionar etiquetas",
  "account_edit.featured_hashtags.placeholder": "Ajude à sua identificação por outros e tenha acesso rápido aos seus tópicos favoritos.",
  "account_edit.featured_hashtags.title": "Etiquetas em destaque",
  "account_edit.field_actions.delete": "Eliminar campo",
  "account_edit.field_actions.edit": "Editar campo",
  "account_edit.field_delete_modal.confirm": "Tem certeza de que deseja excluir este campo personalizado? Esta ação não pode ser desfeita.",
  "account_edit.field_delete_modal.delete_button": "Excluir",
  "account_edit.field_delete_modal.title": "Excluir campo personalizado?",
  "account_edit.field_edit_modal.add_title": "Adicionar campo personalizado",
  "account_edit.field_edit_modal.discard_confirm": "Descartar",
  "account_edit.field_edit_modal.discard_message": "Tem alterações não guardadas. Tem a certeza de que quer descartá-las?",
  "account_edit.field_edit_modal.edit_title": "Editar campo personalizado",
  "account_edit.field_edit_modal.length_warning": "O limite de caracteres recomendado foi excedido. Os utilizadores de dispositivos móveis poderão não ver o seu campo na íntegra.",
  "account_edit.field_edit_modal.link_emoji_warning": "Não recomendamos o uso de emojis personalizados em combinação com URLs. Campos personalizados que contenham ambos serão exibidos apenas como texto, em vez de como hiperligação, para evitar confusão aos utilizadores.",
  "account_edit.field_edit_modal.name_hint": "Ex.: \"Site pessoal\"",
  "account_edit.field_edit_modal.name_label": "Rótulo",
  "account_edit.field_edit_modal.url_warning": "Para adicionar uma hiperligação, inclua {protocol} no início.",
  "account_edit.field_edit_modal.value_hint": "Ex.: \"https://exemplo.eu\"",
  "account_edit.field_edit_modal.value_label": "Valor",
  "account_edit.field_reorder_modal.drag_cancel": "O arrastamento foi cancelado. O campo \"{item}\" foi largado.",
  "account_edit.field_reorder_modal.drag_end": "O campo \"{item}\" foi largado.",
  "account_edit.field_reorder_modal.drag_instructions": "Para reorganizar os campos personalizados, prima a tecla de espaço ou enter. Enquanto arrasta, utilize as teclas de setas para mover o campo para cima ou para baixo. Prima novamente a tecla de espaço ou enter para largar o campo na nova posição, ou prima escape para cancelar.",
  "account_edit.field_reorder_modal.drag_move": "O campo \"{item}\" foi movido.",
  "account_edit.field_reorder_modal.drag_over": "O campo \"{item}\" foi movido para cima de \"{over}\".",
  "account_edit.field_reorder_modal.drag_start": "Apanhou o campo \"{item}\".",
  "account_edit.field_reorder_modal.handle_label": "Arrastar o campo \"{item}\"",
  "account_edit.field_reorder_modal.title": "Reordenar campos",
  "account_edit.image_alt_modal.add_title": "Adicionar texto alternativo",
  "account_edit.image_alt_modal.details_content": "FAZER: <ul> <li>Descreva-se tal como aparece na imagem</li> <li>Utilize a terceira pessoa (por exemplo, “João” em vez de “eu”)</li> <li>Seja sucinto – algumas palavras são, muitas vezes, o suficiente</li> </ul> NÃO FAZER: <ul> <li>Começar com “Foto de” – é redundante para os leitores de ecrã</li> </ul> EXEMPLO: <ul> <li>“João a usar uma camisa verde e óculos”</li> </ul>",
  "account_edit.image_alt_modal.details_title": "Dicas: Texto alternativo para fotos de perfil",
  "account_edit.image_alt_modal.edit_title": "Editar texto alternativo",
  "account_edit.image_alt_modal.text_hint": "O texto alternativo ajuda os utilizadores que usam um leitor de ecrã a entender seu conteúdo.",
  "account_edit.image_alt_modal.text_label": "Texto alternativo",
  "account_edit.image_delete_modal.confirm": "Tem a certeza que pretende eliminar esta imagem? Esta ação é irreversível.",
  "account_edit.image_delete_modal.delete_button": "Eliminar",
  "account_edit.image_delete_modal.title": "Eliminar imagem?",
  "account_edit.image_edit.add_button": "Adicionar imagem",
  "account_edit.image_edit.alt_add_button": "Adicionar texto alternativo",
  "account_edit.image_edit.alt_edit_button": "Editar texto alternativo",
  "account_edit.image_edit.remove_button": "Remover imagem",
  "account_edit.image_edit.replace_button": "Substituir imagem",
  "account_edit.item_list.delete": "Eliminar {name}",
  "account_edit.item_list.edit": "Editar {name}",
  "account_edit.name_modal.add_title": "Adicionar nome a mostrar",
  "account_edit.name_modal.edit_title": "Editar o nome a mostrar",
  "account_edit.profile_tab.button_label": "Personalizar",
  "account_edit.profile_tab.hint.description": "Estas configurações personalizam o que os utilizadores veem no {server} nas aplicações oficiais, mas podem não se aplicar aos utilizadores de outros servidores nem aplicações de terceiros.",
  "account_edit.profile_tab.hint.title": "A apresentação ainda pode variar",
  "account_edit.profile_tab.show_featured.description": "\"Destaques\" é um separador opcional onde pode promover outras contas.",
  "account_edit.profile_tab.show_featured.title": "Mostrar separador “Destaques”",
  "account_edit.profile_tab.show_media.description": "'Media' é um separador opcional que mostra as suas publicações que contêm imagens ou vídeos.",
  "account_edit.profile_tab.show_media.title": "Mostrar separador 'Media'",
  "account_edit.profile_tab.show_media_replies.description": "Quando ativado, o separador 'Media' mostra tanto as suas publicações quanto as suas respostas às publicações de outras pessoas.",
  "account_edit.profile_tab.show_media_replies.title": "Incluir respostas no separador 'Media'",
  "account_edit.save": "Guardar",
  "account_edit.upload_modal.back": "Voltar",
  "account_edit.upload_modal.done": "Concluído",
  "account_edit.upload_modal.next": "Seguinte",
  "account_edit.upload_modal.step_crop.zoom": "Ampliação",
  "account_edit.upload_modal.step_upload.button": "Explorar ficheiros",
  "account_edit.upload_modal.step_upload.dragging": "Solte para transferir",
  "account_edit.upload_modal.step_upload.header": "Escolha uma imagem",
  "account_edit.upload_modal.step_upload.hint": "Formato WEBP, PNG, GIF ou JPG, até {limit} MB.{br}A imagem será redimensionada para {width}x{height} px.",
  "account_edit.upload_modal.title_add.avatar": "Adicionar foto de perfil",
  "account_edit.upload_modal.title_add.header": "Adicionar foto de capa",
  "account_edit.upload_modal.title_replace.avatar": "Substituir foto de perfil",
  "account_edit.upload_modal.title_replace.header": "Substituir foto de capa",
  "account_edit.verified_modal.details": "Adicione credibilidade ao seu perfil no Mastodon verificando links para sites pessoais. Veja como funciona:",
  "account_edit.verified_modal.invisible_link.details": "Adicione o link ao seu cabeçalho. A parte importante é rel=\"me\", que evita a personificação em sites com conteúdo gerado por utilizadores. Você também pode usar uma tag de link no cabeçalho da página em vez de {tag}, mas o HTML deve ser acessível sem executar JavaScript.",
  "account_edit.verified_modal.invisible_link.summary": "Como faço para tornar o link invisível?",
  "account_edit.verified_modal.step1.header": "Copie o código HTML abaixo e cole no cabeçalho do seu site",
  "account_edit.verified_modal.step2.details": "Se já adicionou o seu site como um campo personalizado, será necessário excluí-lo e adicioná-lo novamente para acionar a verificação.",
  "account_edit.verified_modal.step2.header": "Adicione o seu site como um campo personalizado",
  "account_edit.verified_modal.title": "Como adicionar um link verificado",
  "account_edit_tags.add_tag": "Adicionar #{tagName}",
  "account_edit_tags.column_title": "Editar Etiquetas",
  "account_edit_tags.help_text": "As etiquetas destacadas ajudam os utilizadores a descobrir e interagir com o seu perfil. Aparecem como filtros na vista de atividade da sua página de perfil.",
  "account_edit_tags.max_tags_reached": "Atingiu o número máximo de etiquetas destacadas.",
  "account_edit_tags.search_placeholder": "Insira uma etiqueta…",
  "account_edit_tags.suggestions": "Sugestões:",
  "account_edit_tags.tag_status_count": "{count, plural, one {# publicação} other {# publicações}}",
  "account_list.total": "{total, plural, one {# conta} other {# contas}}",
  "admin.dashboard.daily_retention": "Taxa de retenção de utilizadores por dia após a inscrição",
  "admin.dashboard.monthly_retention": "Taxa de retenção de utilizadores por mês após a inscrição",
  "admin.dashboard.retention.average": "Média",
  "admin.dashboard.retention.cohort": "Mês de inscrição",
  "admin.dashboard.retention.cohort_size": "Novos utilizadores",
  "admin.impact_report.instance_accounts": "Perfis de contas que isto eliminaria",
  "admin.impact_report.instance_followers": "Seguidores que os nossos utilizadores perderiam",
  "admin.impact_report.instance_follows": "Seguidores que os utilizadores deles perderiam",
  "admin.impact_report.title": "Resumo do impacto",
  "alert.rate_limited.message": "Volta a tentar depois das {retry_time, time, medium}.",
  "alert.rate_limited.title": "Limite de tentativas",
  "alert.unexpected.message": "Aconteceu algo que não devia.",
  "alert.unexpected.title": "Bolas!",
  "alt_text_badge.title": "Texto descritivo",
  "alt_text_modal.add_alt_text": "Adicionar texto alternativo",
  "alt_text_modal.add_text_from_image": "Adicionar texto a partir da imagem",
  "alt_text_modal.cancel": "Cancelar",
  "alt_text_modal.change_thumbnail": "Alterar miniatura",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Descreve isto para pessoas com problemas de audição…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Descreve isto para pessoas com problemas de visão…",
  "alt_text_modal.done": "Concluído",
  "announcement.announcement": "Mensagem de manutenção",
  "annual_report.announcement.action_build": "Criar o meu Wrapstodon",
  "annual_report.announcement.action_dismiss": "Não, obrigado",
  "annual_report.announcement.action_view": "Ver o meu Wrapstodon",
  "annual_report.announcement.description": "Descubra mais sobre a sua interação no Mastodon ao longo do último ano.",
  "annual_report.announcement.title": "Chegou o Wrapstodon {year}",
  "annual_report.nav_item.badge": "Novo",
  "annual_report.shared_page.donate": "Doar",
  "annual_report.shared_page.footer": "Gerado com {heart} pela equipa do Mastodon",
  "annual_report.shared_page.footer_server_info": "{username} utiliza {domain}, uma das muitas comunidades baseadas no Mastodon.",
  "annual_report.summary.archetype.booster.desc_public": "{name} manteve a procura de publicações para impulsionar, amplificando outros criadores com precisão perfeita.",
  "annual_report.summary.archetype.booster.desc_self": "Permaneceu à procura de publicações para partilhar, promovendo outros criadores com uma precisão perfeita.",
  "annual_report.summary.archetype.booster.name": "O Arqueiro",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.desc_public": "Sabemos que {name} esteve por aí, algures, a apreciar o Mastodon na sua maneira discreta.",
  "annual_report.summary.archetype.lurker.desc_self": "Sabemos que esteve por aí, algures, a apreciar o Mastodon na sua maneira discreta.",
  "annual_report.summary.archetype.lurker.name": "O Estoico",
  "annual_report.summary.archetype.oracle.desc_public": "{name} criou mais publicações novas do que respostas, mantendo o Mastodon atualizado e voltado para o futuro.",
  "annual_report.summary.archetype.oracle.desc_self": "Criou mais publicações novas do que respostas, mantendo o Mastodon atualizado e voltado para o futuro.",
  "annual_report.summary.archetype.oracle.name": "O Oráculo",
  "annual_report.summary.archetype.pollster.desc_public": "{name} criou mais sondagens do que outros tipos de publicações, cultivando a curiosidade no Mastodon.",
  "annual_report.summary.archetype.pollster.desc_self": "Criou mais sondagens do que outros tipos de publicações, cultivando a curiosidade no Mastodon.",
  "annual_report.summary.archetype.pollster.name": "O Questionador",
  "annual_report.summary.archetype.replier.desc_public": "{name} respondeu frequentemente às publicações de outras pessoas, polinizando o Mastodon com novas discussões.",
  "annual_report.summary.archetype.replier.desc_self": "Respondeu frequentemente às publicações de outras pessoas, polinizando o Mastodon com novas discussões.",
  "annual_report.summary.archetype.replier.name": "A Borboleta",
  "annual_report.summary.archetype.reveal": "Revelar o meu arquétipo",
  "annual_report.summary.archetype.reveal_description": "Obrigado por fazer parte do Mastodon! É hora de descobrir qual arquétipo foi incorporado em {year}.",
  "annual_report.summary.archetype.title_public": "Arquétipo de {name}",
  "annual_report.summary.archetype.title_self": "O seu arquétipo",
  "annual_report.summary.close": "Fechar",
  "annual_report.summary.copy_link": "Copiar hiperligação",
  "annual_report.summary.followers.new_followers": "{count, plural, one {novo seguidor} other {novos seguidores}}",
  "annual_report.summary.highlighted_post.boost_count": "Esta publicação foi partilhada {count, plural, one {uma vez} other {# vezes}}.",
  "annual_report.summary.highlighted_post.favourite_count": "Esta publicação foi colocada nos favoritos {count, plural, one {uma vez} other {# vezes}}.",
  "annual_report.summary.highlighted_post.reply_count": "Esta publicação teve {count, plural, one {uma resposta} other {# respostas}}.",
  "annual_report.summary.highlighted_post.title": "Publicação mais popular",
  "annual_report.summary.most_used_app.most_used_app": "aplicação mais utilizada",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "etiqueta mais utilizada",
  "annual_report.summary.most_used_hashtag.used_count": "Incluiu esta etiqueta {count, plural, one {numa publicação} other {em # publicações}}.",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name} incluiu esta etiqueta {count, plural, one {numa publicação} other {em # publicações}}.",
  "annual_report.summary.new_posts.new_posts": "novas publicações",
  "annual_report.summary.percentile.text": "<topLabel>Isso coloca-te no topo</topLabel><percentage></percentage><bottomLabel>dos utilizadores de {domain}.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Este segredo fica entre nós.",
  "annual_report.summary.share_elsewhere": "Partilhar noutro local",
  "annual_report.summary.share_message": "Eu obtive o arquétipo {archetype}!",
  "annual_report.summary.share_on_mastodon": "Partilhar no Mastodon",
  "attachments_list.unprocessed": "(não processado)",
  "audio.hide": "Ocultar áudio",
  "block_modal.remote_users_caveat": "Solicitaremos ao servidor {domain} que respeite a sua decisão. No entanto, o cumprimento não é garantido, sendo que alguns servidores podem gerir bloqueios de forma diferente. As publicações públicas podem continuar visíveis para utilizadores não autenticados.",
  "block_modal.show_less": "Mostrar menos",
  "block_modal.show_more": "Mostrar mais",
  "block_modal.they_will_know": "Ele pode ver que o bloqueaste.",
  "block_modal.title": "Bloquear utilizador?",
  "boost_modal.combo": "Pode clicar em {combo} para não voltar a ver isto",
  "boost_modal.reblog": "Partilhar a publicação?",
  "boost_modal.undo_reblog": "Deixar de partilhar a publicação?",
  "bundle_column_error.copy_stacktrace": "Copiar relatório de erros",
  "bundle_column_error.error.body": "Aconteceu algo de errado ao carregar este componente.",
  "bundle_column_error.error.title": "Oh não!",
  "bundle_column_error.network.body": "Houve um erro ao tentar carregar esta página. Isto pode acontecer devido a um problema temporário com a sua conexão à internet ou a este servidor.",
  "bundle_column_error.network.title": "Erro de rede",
  "bundle_column_error.retry": "Tentar outra vez",
  "bundle_column_error.return": "Voltar à página inicial",
  "bundle_column_error.routing.body": "A página não foi encontrada. Tens a certeza que o endereço ali acima está certo?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Fechar",
  "bundle_modal_error.message": "Algo correu mal ao carregar este ecrã.",
  "bundle_modal_error.retry": "Tenta de novo",
  "callout.dismiss": "Descartar",
  "carousel.current": "<sr>Slide</sr> {current, number} / {max, number}",
  "carousel.slide": "Slide {current, number} de {max, number}",
  "character_counter.recommended": "{currentLength}/{maxLength} caracteres recomendados",
  "character_counter.required": "{currentLength}/{maxLength} caracteres",
  "closed_registrations.other_server_instructions": "Visto que o Mastodon é descentralizado, podes criar uma conta noutro servidor e interagir com este na mesma.",
  "closed_registrations_modal.description": "Criar uma conta em {domain} não é atualmente possível, mas tenha em atenção que não é necessário ter uma conta especificamente em {domain} para usar o Mastodon.",
  "closed_registrations_modal.find_another_server": "Procurar outro servidor",
  "closed_registrations_modal.preamble": "O Mastodon é descentralizado, por isso, não importa onde crie a sua conta: poderá seguir e interagir com qualquer utilizador neste servidor. Pode até alojá-lo você próprio!",
  "closed_registrations_modal.title": "Criar uma conta no Mastodon",
  "collection.share_modal.share_link_label": "Partilhar hiperligação",
  "collection.share_modal.share_via_post": "Publicar no Mastodon",
  "collection.share_modal.share_via_system": "Compartilhar com…",
  "collection.share_modal.title": "Partilhar coleção",
  "collection.share_modal.title_new": "Partilhe a sua nova coleção!",
  "collections.account_count": "{count, plural, one {# conta} other {# contas}}",
  "collections.accounts.empty_description": "Adicione até {count} contas",
  "collections.accounts.empty_editor_title": "Ainda não há ninguém nesta coleção",
  "collections.accounts.empty_title": "Esta coleção está vazia",
  "collections.block_collection_owner": "Bloquear conta",
  "collections.by_account": "por {account_handle}",
  "collections.collection_description": "Descrição",
  "collections.collection_language": "Idioma",
  "collections.collection_language_none": "Nenhum",
  "collections.collection_name": "Nome",
  "collections.collection_topic": "Tópico",
  "collections.confirm_account_removal": "Tem a certeza que quer remover esta conta desta coleção?",
  "collections.content_warning": "Aviso de conteúdo",
  "collections.continue": "Continuar",
  "collections.copy_link": "Copiar hiperligação",
  "collections.copy_link_confirmation": "A hiperligação da coleção foi copiada para a área de transferência",
  "collections.create.accounts_title": "Quem vai destacar nesta coleção?",
  "collections.create.basic_details_title": "Informações básicas",
  "collections.create.steps": "Passo {step}/{total}",
  "collections.create_collection": "Criar coleção",
  "collections.delete_collection": "Eliminar coleção",
  "collections.description_length_hint": "Limite de 100 caracteres",
  "collections.detail.author_added_you_on_date": "{author} adicionou-o em {date}",
  "collections.detail.loading": "A carregar a coleção…",
  "collections.detail.revoke_inclusion": "Remover-me",
  "collections.detail.sensitive_content": "Conteúdo sensível",
  "collections.detail.share": "Partilhar esta coleção",
  "collections.detail.you_are_in_this_collection": "Está em destaque nesta coleção",
  "collections.edit_details": "Editar detalhes",
  "collections.hidden_accounts_description": "Bloqueou ou silenciou {count, plural, one {este utilizador} other {estes utilizadores}}",
  "collections.hidden_accounts_link": "{count, plural, one {# conta escondida} other {# contas escondidas}}",
  "collections.hints.accounts_counter": "{count}/{max} contas",
  "collections.last_updated_at": "Última atualização: {date}",
  "collections.manage_accounts": "Gerir contas",
  "collections.mark_as_sensitive": "Marcar como sensível",
  "collections.mark_as_sensitive_hint": "Oculta a descrição e as contas da coleção por trás de um aviso de conteúdo. O nome da coleção ainda estará visível.",
  "collections.name_length_hint": "Limite de 40 carateres",
  "collections.new_collection": "Nova coleção",
  "collections.remove_account": "Remover",
  "collections.report_collection": "Denunciar esta coleção",
  "collections.revoke_collection_inclusion": "Remover-me desta coleção",
  "collections.revoke_inclusion.confirmation": "Foi removido da coleção \"{collection}\"",
  "collections.revoke_inclusion.error": "Ocorreu um erro, por favor tente novamente mais tarde.",
  "collections.search_accounts_label": "Procurar uma conta para adicionar",
  "collections.search_accounts_max_reached": "Já adicionou o máximo de contas",
  "collections.sensitive": "Sensível",
  "collections.share_short": "Partilhar",
  "collections.suggestions.can_not_add": "Não pode ser adicionada",
  "collections.suggestions.can_not_add_desc": "Estas contas podem ter optado por não participar nas funcionalidades de descoberta, ou podem estar num servidor que não suporta coleções.",
  "collections.suggestions.must_follow": "Deve seguir primeiro",
  "collections.suggestions.must_follow_desc": "Estas contas revêm todos os pedidos de seguidores. Apenas seguidores podem adicioná-las a coleções.",
  "collections.topic_hint": "Adicione uma etiqueta para ajudar outros a entender o tópico principal desta coleção.",
  "collections.topic_special_chars_hint": "Os carateres especiais serão removidos ao guardar",
  "collections.unlisted_collections_description": "Estas não aparecem publicamente no seu perfil. Qualquer pessoa com a hiperligação pode visualizá-las.",
  "collections.unlisted_collections_with_count": "Coleções não listadas ({count})",
  "collections.view_collection": "Ver coleções",
  "collections.visibility_public": "Pública",
  "collections.visibility_public_hint": "Visível nos resultados de pesquisa e outras áreas onde aparecem recomendações.",
  "collections.visibility_title": "Visibilidade",
  "collections.visibility_unlisted": "Não listada",
  "collections.visibility_unlisted_hint": "Visível para qualquer pessoa com uma hiperligação. Não aparece nos resultados de pesquisa e recomendações.",
  "column.about": "Sobre",
  "column.blocks": "Utilizadores bloqueados",
  "column.bookmarks": "Favoritos",
  "column.community": "Cronologia local",
  "column.create_list": "Criar lista",
  "column.direct": "Menções privadas",
  "column.directory": "Explorar perfis",
  "column.domain_blocks": "Domínios bloqueados",
  "column.edit_list": "Editar lista",
  "column.favourites": "Favoritos",
  "column.firehose": "Cronologias em tempo real",
  "column.firehose_local": "Cronologia em tempo real para este servidor",
  "column.firehose_singular": "Cronologia em tempo real",
  "column.follow_requests": "Pedidos de seguidores",
  "column.home": "Início",
  "column.list_members": "Gerir membros da lista",
  "column.lists": "Listas",
  "column.mutes": "Contas silenciadas",
  "column.notifications": "Notificações",
  "column.other_collections": "Coleções de {name}",
  "column.pins": "Publicações afixadas",
  "column.public": "Cronologia federada",
  "column_back_button.label": "Voltar",
  "column.toot": "Toots e respostas",
  "column_header.hide_settings": "Esconder configurações",
  "column_header.moveLeft_settings": "Mover coluna para a esquerda",
  "column_header.moveRight_settings": "Mover coluna para a direita",
  "column_header.pin": "Afixar coluna",
  "column_header.profile": "Perfil",
  "column_header.show_settings": "Mostrar configurações",
  "column_header.unpin": "Desafixar",
  "column_search.cancel": "Cancelar",
  "combobox.close_results": "Fechar resultados",
  "combobox.loading": "A carregar",
  "combobox.no_results_found": "Nenhum resultado para esta pesquisa",
  "combobox.open_results": "Ver resultados",
  "combobox.results_available": "{count, plural, one {# sugestão disponível} other {# sugestões disponíveis}}. Utilize as setas para cima e para baixo para navegar. Pressione a tecla Enter para selecionar.",
  "community.column_settings.local_only": "Apenas local",
  "community.column_settings.media_only": "Apenas media",
  "community.column_settings.remote_only": "Apenas remoto",
  "compose.error.blank_post": "As publicações não podem ficar em branco.",
  "compose.language.change": "Alterar idioma",
  "compose.language.search": "Pesquisar idiomas...",
  "compose.published.body": "Publicado.",
  "compose.published.open": "Abrir",
  "compose.saved.body": "Publicação guardada.",
  "compose_form.direct_message_warning_learn_more": "Quero saber mais",
  "compose_form.encryption_warning": "As publicações na Ciberlândia não têm encriptação ponta-a-ponta. Não partilhes informação sensível aqui, mesmo em privado.",
  "compose_form.hashtag_warning": "Esta publicação não vai ser incluída em nenhuma hashtag por ser não listada. Apenas toots públicos podem ser encontradas com a pesquisa por hashtag.",
  "compose_form.lock_disclaimer": "A tua conta não está {locked}. Qualquer pessoa pode seguir-te e ver as publicações destinadas apenas aos teus seguidores.",
  "compose_form.lock_disclaimer.lock": "em modo protegido",
  "compose_form.placeholder": "Tens algo para contar?",
  "compose_form.poll.add_option": "Adicionar uma opção",
  "compose_form.poll.duration": "Duração da sondagem",
  "compose_form.poll.option_placeholder": "Opção {number}",
  "compose_form.poll.single": "Uma opção",
  "compose_form.poll.switch_to_multiple": "Alterar a sondagem para permitir várias respostas",
  "compose_form.poll.switch_to_single": "Alterar a sondagem para permitir uma única resposta",
  "compose_form.poll.type": "Estilo",
  "compose_form.publish": "Publicar",
  "compose_form.reply": "Responder",
  "compose_form.save_changes": "Atualizar",
  "compose_form.spoiler.marked": "Remover aviso de conteúdo",
  "compose_form.spoiler.unmarked": "Adicionar aviso de conteúdo",
  "compose_form.spoiler_placeholder": "Aviso de conteúdo (opcional)",
  "confirmation_modal.cancel": "Cancelar",
  "confirmations.block.confirm": "Bloquear",
  "confirmations.delete.confirm": "Eliminar",
  "confirmations.delete.message": "De certeza que queres eliminar esta publicação?",
  "confirmations.delete.title": "Eliminar publicação?",
  "confirmations.delete_collection.confirm": "Eliminar",
  "confirmations.delete_collection.message": "Esta ação é irreversível.",
  "confirmations.delete_collection.title": "Eliminar \"{name}\"?",
  "confirmations.delete_list.confirm": "Eliminar",
  "confirmations.delete_list.message": "Tens a certeza de que desejas eliminar permanentemente esta lista?",
  "confirmations.delete_list.title": "Eliminar lista?",
  "confirmations.discard_draft.confirm": "Descartar e continuar",
  "confirmations.discard_draft.edit.cancel": "Retomar edição",
  "confirmations.discard_draft.edit.message": "Continuar irá descartar quaisquer alterações que tenha feito na publicação que está a editar.",
  "confirmations.discard_draft.edit.title": "Descartar alterações à tua publicação?",
  "confirmations.discard_draft.post.cancel": "Retomar rascunho",
  "confirmations.discard_draft.post.message": "Continuar irá descartar a publicação que está a escrever.",
  "confirmations.discard_draft.post.title": "Descartar o rascunho da publicação?",
  "confirmations.discard_edit_media.confirm": "Descartar",
  "confirmations.discard_edit_media.message": "Tem alterações não guardadas na descrição ou na pré-visualização do ficheiro multimédia. Deseja ignorá-las na mesma?",
  "confirmations.follow_to_list.confirm": "Seguir e adicionar à lista",
  "confirmations.follow_to_list.message": "Tens de seguir {name} para o adicionares a uma lista.",
  "confirmations.follow_to_list.title": "Seguir utilizador?",
  "confirmations.hide_featured_tab.confirm": "Esconder separador",
  "confirmations.hide_featured_tab.intro": "Pode alterar esta configuração a qualquer momento em <i>Editar perfil > Definições dos separadores de perfil</i>.",
  "confirmations.hide_featured_tab.message": "Isto irá ocultar o separador para os utilizadores em {serverName} e noutros servidores que executem a versão mais recente do Mastodon. A apresentação pode variar noutros casos.",
  "confirmations.hide_featured_tab.title": "Esconder o separador \"Destaques\"?",
  "confirmations.logout.confirm": "Terminar sessão",
  "confirmations.logout.message": "Tens a certeza de que queres terminar a sessão?",
  "confirmations.logout.title": "Terminar sessão?",
  "confirmations.missing_alt_text.confirm": "Adicionar texto alternativo",
  "confirmations.missing_alt_text.message": "A sua publicação contém ficheiros multimédia sem texto alternativo. Adicionar descrições ajuda a tornar o seu conteúdo acessível a mais pessoas.",
  "confirmations.missing_alt_text.secondary": "Publicar mesmo assim",
  "confirmations.missing_alt_text.title": "Adicionar texto alternativo?",
  "confirmations.mute.confirm": "Ocultar",
  "confirmations.private_quote_notify.cancel": "Voltar à edição",
  "confirmations.private_quote_notify.confirm": "Publicar",
  "confirmations.private_quote_notify.do_not_show_again": "Não mostrar novamente esta mensagem",
  "confirmations.private_quote_notify.message": "A pessoa que está a citar e outras mencionadas serão notificadas e poderão ver a sua publicação, mesmo que não o sigam.",
  "confirmations.private_quote_notify.title": "Partilhar com seguidores e utilizadores mencionados?",
  "confirmations.quiet_post_quote_info.dismiss": "Não me relembre novamente",
  "confirmations.quiet_post_quote_info.got_it": "Entendido",
  "confirmations.quiet_post_quote_info.message": "Ao citar uma publicação não listada, a tua publicação não será exibida nos destaques.",
  "confirmations.quiet_post_quote_info.title": "Citação de publicação não listada",
  "confirmations.redraft.confirm": "Eliminar e reescrever",
  "confirmations.redraft.message": "Tem a certeza que pretende eliminar e tornar a escrever esta publicação? Os favoritos e as partilhas perder-se-ão e as respostas à publicação original ficarão órfãs.",
  "confirmations.redraft.title": "Eliminar e reescrever publicação?",
  "confirmations.remove_from_followers.confirm": "Remover seguidor",
  "confirmations.remove_from_followers.message": "{name} vai parar de seguir-te. Tens a certeza que prentedes continuar?",
  "confirmations.remove_from_followers.title": "Remover seguidor?",
  "confirmations.revoke_collection_inclusion.confirm": "Remover-me",
  "confirmations.revoke_collection_inclusion.title": "Remover-se desta coleção?",
  "confirmations.revoke_quote.confirm": "Remover publicação",
  "confirmations.revoke_quote.message": "Esta ação é irreversível.",
  "confirmations.revoke_quote.title": "Remover publicação?",
  "confirmations.unblock.confirm": "Desbloquear",
  "confirmations.unblock.title": "Desbloquear {name}?",
  "confirmations.unfollow.confirm": "Deixar de seguir",
  "confirmations.unfollow.title": "Deixar de seguir {name}?",
  "confirmations.withdraw_request.confirm": "Retirar pedido",
  "confirmations.withdraw_request.title": "Retirar pedido para seguir {name}?",
  "content_warning.hide": "Ocultar publicação",
  "content_warning.show": "Mostrar mesmo assim",
  "content_warning.show_more": "Mostrar mais",
  "content_warning.show_short": "Mostrar",
  "conversation.delete": "Eliminar conversa",
  "conversation.mark_as_read": "Marcar como lida",
  "conversation.open": "Abrir conversa",
  "conversation.with": "Com {names}",
  "copy_icon_button.copied": "Copiado para a área de transferência",
  "copy_icon_button.copy_this_text": "Copiar link para a área de transferência",
  "copypaste.copied": "Copiado",
  "copypaste.copy_to_clipboard": "Copiar para a área de transferência",
  "directory.federated": "Do fediverso conhecido",
  "directory.local": "Apenas de {domain}",
  "directory.new_arrivals": "Recém-chegados",
  "directory.recently_active": "Recentemente ativo",
  "disabled_account_banner.account_settings": "Definições da conta",
  "disabled_account_banner.text": "A tua conta {disabledAccount} está desactivada.",
  "dismissable_banner.community_timeline": "Estas são as publicações públicas mais recentes de pessoas cujas contas são hospedadas por {domain}.",
  "dismissable_banner.dismiss": "Descartar",
  "dismissable_banner.public_timeline": "Estas são as publicações públicas mais recentes de pessoas no fediverso que as pessoas em {domain} seguem.",
  "domain_block_modal.block": "Bloquear servidor",
  "domain_block_modal.block_account_instead": "Em vez disso, bloquear @{name}",
  "domain_block_modal.they_can_interact_with_old_posts": "As pessoas deste servidor podem interagir com as tuas publicações antigas.",
  "domain_block_modal.they_cant_follow": "Ninguém deste servidor pode seguir-te.",
  "domain_block_modal.they_wont_know": "Eles não saberão que foram bloqueados.",
  "domain_block_modal.title": "Bloquear domínio?",
  "domain_block_modal.you_will_lose_num_followers": "Irás perder {followersCount, plural, one {{followersCountDisplay} seguidor} other {{followersCountDisplay} seguidores}} e {followingCount, plural, one {{followingCountDisplay} pessoa que estás a seguir} other {{followingCountDisplay} pessoas que estás a seguir}}.",
  "domain_block_modal.you_will_lose_relationships": "Irás perder todos os seguidores e pessoas que segues deste servidor.",
  "domain_block_modal.you_wont_see_posts": "Não verás publicações ou notificações de utilizadores neste servidor.",
  "dropdown.empty": "Selecione uma opção",
  "email_subscriptions.email": "E-mail",
  "email_subscriptions.form.action": "Subscrever",
  "email_subscriptions.form.bottom": "Receba publicações na sua caixa de correio sem criar uma conta no Mastodon. Pode cancelar a qualquer momento. Para mais informações, consulte a <a>Política de Privacidade</a>.",
  "email_subscriptions.form.title": "Inscreva-se para receber por e-mail atualizações de {name}",
  "email_subscriptions.submitted.lead": "Verifique a sua caixa de correio para concluir o registo para receber atualizações por e-mail.",
  "email_subscriptions.submitted.title": "Mais um passo",
  "email_subscriptions.validation.email.blocked": "Fornecedor de e-mail bloqueado",
  "email_subscriptions.validation.email.invalid": "Endereço de e-mail inválido",
  "embed.instructions": "Incorpora esta publicação no teu site copiando o código abaixo.",
  "embed.preview": "Eis o aspeto que terá:",
  "emoji_button.activity": "Atividade",
  "emoji_button.clear": "Limpar",
  "emoji_button.custom": "Emoji desta instância",
  "emoji_button.flags": "Bandeiras",
  "emoji_button.food": "Comida & Bebida",
  "emoji_button.label": "Introduzir Emoji",
  "emoji_button.nature": "Natureza",
  "emoji_button.not_found": "Não há emoji!! (╯°□°）╯︵ ┻━┻",
  "emoji_button.objects": "Objectos",
  "emoji_button.people": "Pessoas",
  "emoji_button.recent": "Recentemente usados",
  "emoji_button.search": "Pesquisar...",
  "emoji_button.search_results": "Resultados da pesquisa",
  "emoji_button.symbols": "Símbolos",
  "emoji_button.travel": "Viagens e lugares",
  "empty_column.account_featured.other": "{acct} ainda não destacou nada.",
  "empty_column.account_featured_self.no_collections_button": "Criar uma coleção",
  "empty_column.account_featured_self.no_collections_hide_tab": "Ao invés disso, ocultar este separador",
  "empty_column.account_featured_self.showcase_accounts": "Destaque as suas contas favoritas",
  "empty_column.account_featured_self.showcase_accounts_desc": "As coleções são listas curadas de contas destinadas a ajudar outras pessoas a descobrir mais do Fediverso.",
  "empty_column.account_featured_unknown.other": "Esta conta ainda não destacou nada.",
  "empty_column.account_hides_collections": "Este utilizador escolheu não disponibilizar esta informação",
  "empty_column.account_suspended": "Conta suspensa",
  "empty_column.account_timeline": "Sem publicações por aqui!",
  "empty_column.account_unavailable": "Perfil indisponível",
  "empty_column.blocks": "Ainda não bloqueaste nenhum utilizador.",
  "empty_column.bookmarked_statuses": "Ainda não tem nenhuma publicação salva. Quando salvar uma, ela aparecerá aqui.",
  "empty_column.community": "A cronologia local está vazia. Escreve algo publicamente para começar!",
  "empty_column.direct": "Ainda não tens qualquer menção privada. Quando enviares ou receberes uma, ela irá aparecer aqui.",
  "empty_column.disabled_feed": "Esta cronologia foi desativada pelos administradores do seu servidor.",
  "empty_column.domain_blocks": "Ainda não há qualquer domínio bloqueado.",
  "empty_column.explore_statuses": "Não há nada em destaque neste momento. Volte mais tarde!",
  "empty_column.favourited_statuses": "Ainda não assinalaste qualquer publicação como favorita. Quando o fizeres, ela aparecerá aqui.",
  "empty_column.favourites": "Ainda ninguém assinalou esta publicação como favorita. Quando alguém o fizer, ela aparecerá aqui.",
  "empty_column.follow_requests": "Ainda não tens nenhum pedido de seguidor. Quando receberes algum, ele irá aparecer aqui.",
  "empty_column.followed_tags": "Ainda não segues nenhuma etiqueta. Quando o fizeres, ela aparecerá aqui.",
  "empty_column.hashtag": "Não foram encontradas publicações com esta #etiqueta.",
  "empty_column.home": "A tua linha cronológica inicial está vazia! Segue mais pessoas para a preencher.",
  "empty_column.list": "Ainda não existem publicações nesta lista. Quando os membros desta lista fizerem novas publicações, elas aparecerão aqui.",
  "empty_column.mutes": "Ainda não ocultaste nenhum utilizador.",
  "empty_column.notification_requests": "Tudo limpo! Não há nada aqui. Quando receberes novas notificações, elas aparecerão aqui conforme as tuas configurações.",
  "empty_column.notifications": "Ainda não tens quaisquer notificações. Quando outras pessoas interagirem contigo, verás isso aqui.",
  "empty_column.public": "Não há nada aqui! Escreve algo publicamente ou segue outros utilizadores para veres aqui os conteúdos públicos",
  "empty_state.no_results": "Sem resultados",
  "error.no_hashtag_feed_access": "Inscreva-se ou inicie sessão para ver e seguir esta etiqueta.",
  "error.unexpected_crash.explanation": "Devido a um erro no nosso código ou a um problema de compatibilidade do navegador, esta página não pode ser apresentada corretamente.",
  "error.unexpected_crash.explanation_addons": "Esta página não pode ser mostrada corretamente. Este erro provavelmente é causado por um complemento do navegador ou ferramentas de tradução automática.",
  "error.unexpected_crash.next_steps": "Tenta atualizar a página. Se isso não ajudar, podes usar o Mastodon através de um navegador diferente ou uma aplicação nativa.",
  "error.unexpected_crash.next_steps_addons": "Tenta desativá-los e atualizar a página. Se isso não ajudar, poderá ainda ser possível utilizar o Mastodon através de um navegador diferente ou de uma aplicação nativa.",
  "errors.unexpected_crash.copy_stacktrace": "Copiar o stacktrace para a área de transferência",
  "errors.unexpected_crash.report_issue": "Reportar problema",
  "explore.suggested_follows": "Pessoas",
  "explore.title": "Em destaque",
  "explore.trending_links": "Notícias",
  "explore.trending_statuses": "Publicações",
  "explore.trending_tags": "#Etiquetas",
  "featured_carousel.current": "<sr>Publicação</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, one {Publicação Afixada} other {Publicações Afixadas}}",
  "featured_carousel.slide": "Publicação {current, number} de {max, number}",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "Ultimamente, tem publicado sobre {items}. Quer adicioná-las às etiquetas destacadas?",
  "featured_tags.suggestions.add": "Adicionar",
  "featured_tags.suggestions.added": "Pode gerir as suas etiquetas destacadas a qualquer momento em <link>Editar perfil > Etiquetas destacadas</link>.",
  "featured_tags.suggestions.dismiss": "Não, obrigado",
  "filter_modal.added.context_mismatch_explanation": "Esta categoria de filtro não se aplica ao contexto em que acedeste a esta publicação. Se pretenderes que esta publicação seja filtrada também neste contexto, terás que editar o filtro.",
  "filter_modal.added.context_mismatch_title": "O contexto não coincide!",
  "filter_modal.added.expired_explanation": "Esta categoria de filtro expirou, tens de alterar a data de validade para que ele seja aplicado.",
  "filter_modal.added.expired_title": "Filtro expirado!",
  "filter_modal.added.review_and_configure": "Para rever e configurar em pormenor esta categoria de filtro, vai a {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Definições do filtro",
  "filter_modal.added.settings_link": "página de definições",
  "filter_modal.added.short_explanation": "Esta publicação foi adicionada à categoria de filtro {title}.",
  "filter_modal.added.title": "Filtro adicionado!",
  "filter_modal.select_filter.context_mismatch": "não se aplica a este contexto",
  "filter_modal.select_filter.expired": "expirado",
  "filter_modal.select_filter.prompt_new": "Nova categoria: {name}",
  "filter_modal.select_filter.search": "Pesquisar ou criar",
  "filter_modal.select_filter.subtitle": "Usa uma categoria existente ou cria uma nova",
  "filter_modal.select_filter.title": "Filtrar esta publicação",
  "filter_modal.title.status": "Filtrar uma publicação",
  "filter_warning.matches_filter": "Corresponde ao filtro “<span>{title}</span>”",
  "filtered_notifications_banner.pending_requests": "De {count, plural, =0 {ninguém} one {uma pessoa} other {# pessoas}} que talvez conheças",
  "filtered_notifications_banner.title": "Notificações filtradas",
  "firehose.all": "Todas",
  "firehose.local": "Este servidor",
  "firehose.remote": "Outros servidores",
  "follow_request.authorize": "Autorizar",
  "follow_request.reject": "Rejeitar",
  "follow_requests.unlocked_explanation": "Apesar de a tua conta não ser privada, a administração da Ciberlândia é da opinião que poderás querer rever manualmente os pedidos para seguir dessas contas.",
  "follow_suggestions.curated_suggestion": "Escolha da equipe",
  "follow_suggestions.dismiss": "Não mostrar novamente",
  "follow_suggestions.featured_longer": "Escolhido a dedo pela equipa de {domain}",
  "follow_suggestions.friends_of_friends_longer": "Popular entre as pessoas que segues",
  "follow_suggestions.hints.featured": "Este perfil foi escolhido a dedo pela equipa de {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Este perfil é popular entre as pessoas que estás a seguir.",
  "follow_suggestions.hints.most_followed": "Este perfil é um dos mais seguidos em {domain}.",
  "follow_suggestions.hints.most_interactions": "Este perfil tem recebido recentemente muita atenção em {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Este perfil é semelhante aos perfis que seguiste recentemente.",
  "follow_suggestions.personalized_suggestion": "Sugestão personalizada",
  "follow_suggestions.popular_suggestion": "Sugestão popular",
  "follow_suggestions.popular_suggestion_longer": "Popular em {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Semelhantes aos perfis que seguiste recentemente",
  "follow_suggestions.view_all": "Ver tudo",
  "follow_suggestions.who_to_follow": "Quem seguir",
  "followed_tags": "Etiquetas seguidas",
  "followers.hide_other_followers": "Este utilizador optou por não mostrar os seus outros seguidores",
  "followers.title": "A seguir {name}",
  "following.hide_other_following": "Este utilizador optou por não mostrar quem mais segue",
  "following.title": "Seguido por {name}",
  "footer.about": "Sobre",
  "footer.about_mastodon": "Sobre o Mastodon",
  "footer.about_server": "Sobre {domain}",
  "footer.about_this_server": "Sobre",
  "footer.directory": "Índice de contas",
  "footer.get_app": "Obter a aplicação",
  "footer.keyboard_shortcuts": "Atalhos de teclado",
  "footer.privacy_policy": "Política de privacidade",
  "footer.source_code": "Ver código-fonte",
  "footer.status": "Estado",
  "footer.terms_of_service": "Termos de serviço",
  "form_error.blank": "O campo não pode ficar em branco.",
  "form_field.optional": "(opcional)",
  "getting_started.heading": "Casa de partida",
  "hashtag.admin_moderation": "Abrir interface de moderação para #{name}",
  "hashtag.browse": "Ver publicações em #{hashtag}",
  "hashtag.browse_from_account": "Ver publicações de @{name} em #{hashtag}",
  "hashtag.column_header.tag_mode.all": "e {additional}",
  "hashtag.column_header.tag_mode.any": "ou {additional}",
  "hashtag.column_header.tag_mode.none": "sem {additional}",
  "hashtag.column_settings.select.no_options_message": "Não foram encontradas sugestões",
  "hashtag.column_settings.select.placeholder": "Introduz as #hashtags…",
  "hashtag.column_settings.tag_mode.all": "Todos estes",
  "hashtag.column_settings.tag_mode.any": "Qualquer destes",
  "hashtag.column_settings.tag_mode.none": "Nenhum destes",
  "hashtag.column_settings.tag_toggle": "Incluir etiquetas adicionais para esta coluna",
  "hashtag.counter_by_accounts": "{count, plural,one {{counter} participante} other {{counter} participantes}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} publicação} other {{counter} publicações}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} publicação} other {{counter} publicações}} hoje",
  "hashtag.feature": "Destacar no perfil",
  "hashtag.follow": "Seguir etiqueta",
  "hashtag.mute": "Silenciar #{hashtag}",
  "hashtag.unfeature": "Não destacar no perfil",
  "hashtag.unfollow": "Deixar de seguir a etiqueta",
  "hashtags.and_other": "…e {count, plural, other {mais #}}",
  "hints.profiles.followers_may_be_missing": "É possível que não estejam a ser mostrados todos os seguidores deste perfil.",
  "hints.profiles.follows_may_be_missing": "É possível que não estejam a ser mostrados todos os seguidos por este perfil.",
  "hints.profiles.posts_may_be_missing": "É possível que não estejam a ser mostradas todas as publicações deste perfil.",
  "hints.profiles.see_more_followers": "Ver mais seguidores em {domain}",
  "hints.profiles.see_more_follows": "Ver mais perfis seguidos em {domain}",
  "hints.profiles.see_more_posts": "Ver mais publicações em {domain}",
  "home.column_settings.show_quotes": "Mostrar citações",
  "home.column_settings.show_reblogs": "Mostrar partilhas",
  "home.column_settings.show_replies": "Mostrar respostas",
  "home.hide_announcements": "Ocultar anúncios da instância",
  "home.pending_critical_update.body": "Por favor, atualize o teu servidor Mastodon assim que possível!",
  "home.pending_critical_update.link": "Ver atualizações",
  "home.pending_critical_update.title": "Está disponível uma atualização de segurança crítica!",
  "home.show_announcements": "Mostrar mensagens de manutenção",
  "ignore_notifications_modal.disclaimer": "O Mastodon não pode informar os utilizadores de que ignoraste as notificações deles. Ignorar as notificações não impedirá que as mensagens sejam enviadas.",
  "ignore_notifications_modal.filter_instead": "Em vez disso, filtrar",
  "ignore_notifications_modal.filter_to_act_users": "Ainda poderás aceitar, rejeitar ou reportar utilizadores",
  "ignore_notifications_modal.filter_to_avoid_confusion": "A filtragem ajuda a evitar potenciais equívocos",
  "ignore_notifications_modal.filter_to_review_separately": "Podes rever as notificações filtradas separadamente",
  "ignore_notifications_modal.ignore": "Ignorar notificações",
  "ignore_notifications_modal.limited_accounts_title": "Ignorar notificações de contas moderadas?",
  "ignore_notifications_modal.new_accounts_title": "Ignorar notificações de contas novas?",
  "ignore_notifications_modal.not_followers_title": "Ignorar notificações de pessoas que não te seguem?",
  "ignore_notifications_modal.not_following_title": "Ignorar notificações de pessoas que não segues?",
  "ignore_notifications_modal.private_mentions_title": "Ignorar notificações de menções privadas não solicitadas?",
  "info_button.label": "Ajuda",
  "info_button.what_is_alt_text": "<h1>O que é texto alternativo?</h1> <p>O texto alternativo fornece descrições de imagens para pessoas com deficiências visuais, ligações de baixa largura de banda ou pessoas que procuram um contexto adicional.</p> <p>Pode melhorar a acessibilidade e a compreensão de todos escrevendo um texto alternativo claro, conciso e objetivo.</p> <ul> <li>Capte os elementos importantes</li> <li>Resuma o texto em imagens</li> <li>Use uma estrutura de frase regular</li> <li>Evite informações redundantes</li> <li>Concentre-se nas tendências e principais conclusões em imagens complexas (como diagramas ou mapas)</li> </ul>",
  "interaction_modal.action": "Para interagir com a publicação de {name}, necessita de iniciar sessão na sua conta em qualquer servidor Mastodon que utilize.",
  "interaction_modal.go": "Ir",
  "interaction_modal.no_account_yet": "Ainda não tens conta?",
  "interaction_modal.on_another_server": "Num servidor diferente",
  "interaction_modal.on_this_server": "Neste servidor",
  "interaction_modal.title": "Iniciar sessão para continuar",
  "interaction_modal.username_prompt": "Por exemplo: {example}",
  "intervals.full.days": "{number, plural, one {# dia} other {# dias}}",
  "intervals.full.hours": "{number, plural, one {# hora} other {# horas}}",
  "intervals.full.minutes": "{number, plural, one {# minuto} other {# minutos}}",
  "keyboard_shortcuts.back": "voltar atrás",
  "keyboard_shortcuts.blocked": "abrir a lista de utilizadores bloqueados",
  "keyboard_shortcuts.boost": "Partilhar a publicação",
  "keyboard_shortcuts.column": "focar uma publicação numa das colunas",
  "keyboard_shortcuts.compose": "focar área de texto da publicação",
  "keyboard_shortcuts.description": "Descrição",
  "keyboard_shortcuts.direct": "Abrir coluna de menções privadas",
  "keyboard_shortcuts.down": "mover para baixo na lista",
  "keyboard_shortcuts.enter": "abrir publicação",
  "keyboard_shortcuts.explore": "Abrir linha do tempo em destaque",
  "keyboard_shortcuts.favourite": "assinalar como favorita",
  "keyboard_shortcuts.favourites": "abrir lista de favoritos",
  "keyboard_shortcuts.federated": "abrir a cronologia federada",
  "keyboard_shortcuts.heading": "Atalhos de teclado",
  "keyboard_shortcuts.home": "abrir a cronologia na página inicial",
  "keyboard_shortcuts.hotkey": "Atalho",
  "keyboard_shortcuts.legend": "mostrar esta legenda",
  "keyboard_shortcuts.load_more": "Focar botão \"Carregar mais\"",
  "keyboard_shortcuts.local": "abrir a cronologia local",
  "keyboard_shortcuts.mention": "mencionar o autor",
  "keyboard_shortcuts.muted": "abrir a lista dos utilizadores ocultados",
  "keyboard_shortcuts.my_profile": "abrir o teu perfil",
  "keyboard_shortcuts.notifications": "abrir a coluna das notificações",
  "keyboard_shortcuts.open_media": "Abrir media",
  "keyboard_shortcuts.pinned": "abrir lista de publicações fixadas",
  "keyboard_shortcuts.profile": "abrir o perfil do autor",
  "keyboard_shortcuts.quote": "Citar publicação",
  "keyboard_shortcuts.reply": "responder à publicação",
  "keyboard_shortcuts.requests": "abrir a lista dos pedidos de seguidor",
  "keyboard_shortcuts.search": "focar barra de pesquisa",
  "keyboard_shortcuts.spoilers": "para mostrar/esconder o campo AC",
  "keyboard_shortcuts.start": "abrir a coluna dos \"primeiros passos\"",
  "keyboard_shortcuts.toggle_hidden": "mostrar / esconder texto atrás do aviso de conteúdo",
  "keyboard_shortcuts.toggle_sensitivity": "Mostrar / Ocultar media",
  "keyboard_shortcuts.toot": "criar uma nova publicação",
  "keyboard_shortcuts.top": "Mover para o topo da lista",
  "keyboard_shortcuts.unfocus": "remover o foco da área de texto / pesquisa",
  "keyboard_shortcuts.up": "mover para cima na lista",
  "learn_more_link.got_it": "Entendido",
  "learn_more_link.learn_more": "Saber mais",
  "lightbox.close": "Fechar",
  "lightbox.compress": "Comprimir caixa de visualização de imagem",
  "lightbox.expand": "Expandir caixa de visualização de imagem",
  "lightbox.next": "Próximo",
  "lightbox.previous": "Anterior",
  "lightbox.zoom_in": "Ampliar para o tamanho real",
  "lightbox.zoom_out": "Ajustar para caber",
  "limited_account_hint.action": "Mostrar perfil mesmo assim",
  "link_preview.author": "Por {name}",
  "link_preview.more_from_author": "Mais de {name}",
  "link_preview.shares": "{count, plural, one {{counter} publicação} other {{counter} publicações}}",
  "lists.account.add": "Adicionar à lista",
  "lists.account.remove": "Retirar da lista",
  "lists.delete": "Apagar lista",
  "lists.edit": "Editar lista",
  "lists.exclusive": "Ocultar membros na página inicial",
  "lists.exclusive_hint": "Se alguém estiver nesta lista, oculta-o na cronologia da tua página inicial para evitar veres as publicações dessa pessoa duas vezes.",
  "lists.find_users_to_add": "Encontrar utilizadores para adicionar",
  "lists.list_members_count": "{count, plural, one {# membro} other {# membros}}",
  "lists.list_name": "Nome da lista",
  "lists.new_list_name": "Nome da nova lista",
  "lists.no_lists_yet": "Ainda não existem listas.",
  "lists.no_members_yet": "Ainda não existem membros.",
  "lists.no_results_found": "Nenhuns resultados encontrados.",
  "lists.remove_member": "Remover",
  "lists.replies_policy.followed": "Qualquer utilizador seguido",
  "lists.replies_policy.list": "Membros da lista",
  "lists.replies_policy.none": "Ninguém",
  "lists.replies_policy.title": "Mostrar respostas a:",
  "lists.search": "Pesquisa entre as contas que segues",
  "lists.subheading": "As tuas listas",
  "load_pending": "{count, plural, one {# novo item} other {# novos itens}}",
  "loading_indicator.label": "A carregar…",
  "media_gallery.hide": "Ocultar",
  "moved_to_account_banner.text": "A tua conta {disabledAccount} está neste momento desativada porque migraste para {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Ocultar das notificações",
  "mute_modal.hide_options": "Ocultar opções",
  "mute_modal.indefinite": "Indefinidamente",
  "mute_modal.show_options": "Mostrar opções",
  "mute_modal.they_can_mention_and_follow": "Ele pode mencionar-te e seguir-te, mas não o verás.",
  "mute_modal.they_wont_know": "Ele não saberá que o ocultaste.",
  "mute_modal.title": "Ocultar utilizador?",
  "mute_modal.you_wont_see_mentions": "Não verás publicações que mencionem este utilizador.",
  "mute_modal.you_wont_see_posts": "Não verás as publicações dele e ele não poderá ver as tuas publicações.",
  "navigation_bar.about": "Sobre",
  "navigation_bar.account_settings": "Palavra-passe e segurança",
  "navigation_bar.administration": "Administração",
  "navigation_bar.advanced_interface": "Abrir na interface web avançada",
  "navigation_bar.automated_deletion": "Eliminação automática de publicações",
  "navigation_bar.blocks": "Utilizadores bloqueados",
  "navigation_bar.bookmarks": "Itens salvos",
  "navigation_bar.collections": "Coleções",
  "navigation_bar.direct": "Menções privadas",
  "navigation_bar.domain_blocks": "Domínios escondidos",
  "navigation_bar.favourites": "Favoritos",
  "navigation_bar.filters": "Palavras ocultadas",
  "navigation_bar.follow_requests": "Seguidores pendentes",
  "navigation_bar.followed_tags": "Etiquetas seguidas",
  "navigation_bar.follows_and_followers": "Seguindo e seguidores",
  "navigation_bar.import_export": "Importar e exportar",
  "navigation_bar.lists": "Listas",
  "navigation_bar.live_feed_local": "Cronologia local",
  "navigation_bar.live_feed_public": "Cronologia federada",
  "navigation_bar.logout": "Sair",
  "navigation_bar.moderation": "Moderação",
  "navigation_bar.more": "Mais",
  "navigation_bar.mutes": "Utilizadores ocultados",
  "navigation_bar.opened_in_classic_interface": "Por norma, publicações, contas e outras páginas específicas são abertas na interface web clássica.",
  "navigation_bar.preferences": "Preferências",
  "navigation_bar.privacy_and_reach": "Privacidade e alcance",
  "navigation_bar.search": "Pesquisar",
  "navigation_bar.search_trends": "Pesquisar / Em destaque",
  "navigation_panel.collapse_followed_tags": "Recolher o menu de etiquetas seguidas",
  "navigation_panel.collapse_lists": "Recolher lista de menu",
  "navigation_panel.expand_followed_tags": "Expandir o menu de etiquetas seguidas",
  "navigation_panel.expand_lists": "Expandir lista de menu",
  "not_signed_in_indicator.not_signed_in": "Tens de iniciar a sessão para utilizares esta funcionalidade.",
  "notification.added_to_collection": "{name} adicionou-o a uma coleção",
  "notification.admin.report": "{name} denunciou {target}",
  "notification.admin.report_account": "{name} denunciou {count, plural, one {uma publicação} other {# publicações}} de {target} por {category}",
  "notification.admin.report_account_other": "{name} denunciou {count, plural, one {uma publicação} other {# publicações}} de {target}",
  "notification.admin.report_statuses": "{name} denunciou {target} por {category}",
  "notification.admin.report_statuses_other": "{name} denunciou {target}",
  "notification.admin.sign_up": "{name} inscreveu-se",
  "notification.admin.sign_up.name_and_others": "{name} e {count, plural, one {# outro} other {# outros}} inscreveram-se",
  "notification.annual_report.message": "O teu #Wrapstodon {year} está à espera! Ele revela os destaques e os momentos memoráveis do teu ano no Mastodon!",
  "notification.annual_report.view": "Ver #Wrapstodon",
  "notification.collection_update": "{name} editou uma coleção em está incluído",
  "notification.favourite": "{name} assinalou a tua publicação como favorita",
  "notification.favourite.name_and_others_with_link": "{name} e <a>{count, plural, one {# outro} other {# outros}}</a> assinalaram a tua publicação como favorita",
  "notification.favourite_pm": "{name} assinalou como favorita a sua menção privada",
  "notification.favourite_pm.name_and_others_with_link": "{name} e <a>{count, plural, one {# outro favoritou} other {# outros favoritaram}}</a> a tua menção privada",
  "notification.follow": "{name} começou a seguir-te",
  "notification.follow.name_and_others": "{name} e <a>{count, plural, one {# outro seguiram-te} other {# outros seguiram-te}}</a>",
  "notification.follow_request": "{name} pediu para seguir-te",
  "notification.follow_request.name_and_others": "{name} e {count, plural, one {# outro} other {# outros}} pediram para seguir-te",
  "notification.label.mention": "Menção",
  "notification.label.private_mention": "Menção privada",
  "notification.label.private_reply": "Resposta privada",
  "notification.label.quote": "{name} citou a tua publicação",
  "notification.label.reply": "Resposta",
  "notification.mention": "Menção",
  "notification.mentioned_you": "{name} mencionou-te",
  "notification.moderation-warning.learn_more": "Saber mais",
  "notification.moderation_warning": "Recebeu um aviso de moderação",
  "notification.moderation_warning.action_delete_statuses": "Algumas das suas publicações foram removidas.",
  "notification.moderation_warning.action_disable": "A sua conta foi desativada.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Algumas das suas publicações foram assinaladas como sensíveis.",
  "notification.moderation_warning.action_none": "A sua conta recebeu um aviso de moderação.",
  "notification.moderation_warning.action_sensitive": "As suas publicações serão, a partir de agora, assinaladas como sensíveis.",
  "notification.moderation_warning.action_silence": "A sua conta foi limitada.",
  "notification.moderation_warning.action_suspend": "A sua conta foi suspensa.",
  "notification.own_poll": "A tua sondagem terminou",
  "notification.poll": "Uma sondagem em que participaste chegou ao fim",
  "notification.quoted_update": "{name} editou uma publicação que citou",
  "notification.reblog": "{name} partilhou a tua publicação",
  "notification.reblog.name_and_others_with_link": "{name} e <a>{count, plural, one {# outro} other {# outros}}</a> partilharam a tua publicação",
  "notification.relationships_severance_event": "Perdeu as ligações com {name}",
  "notification.relationships_severance_event.account_suspension": "Um administrador de {from} suspendeu {target}, o que significa que já não podes receber atualizações dele ou interagir com ele.",
  "notification.relationships_severance_event.domain_block": "Um administrador de {from} bloqueou {target}, incluindo {followersCount} dos teus seguidores e {followingCount, plural, one {# conta} other {# contas}} que segues.",
  "notification.relationships_severance_event.learn_more": "Saber mais",
  "notification.relationships_severance_event.user_domain_block": "Bloqueaste {target}, removendo {followersCount} dos teus seguidores e {followingCount, plural, one {# conta} other {# contas}} que segues.",
  "notification.status": "{name} acabou de publicar",
  "notification.update": "{name} editou uma publicação",
  "notification_requests.accept": "Aceitar",
  "notification_requests.accept_multiple": "{count, plural, one {Aceitar # pedido…} other {Aceitar # pedidos…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Aceitar pedido} other {Aceitar pedidos}}",
  "notification_requests.confirm_accept_multiple.message": "Estás prestes a aceitar {count, plural, one {um pedido de notificação} other {# pedidos de notificação}}. Tens a certeza de que pretendes continuar?",
  "notification_requests.confirm_accept_multiple.title": "Aceitar pedidos de notificação?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Rejeitar pedido} other {Rejeitar pedidos}}",
  "notification_requests.confirm_dismiss_multiple.message": "Estás prestes a rejeitar {count, plural, one {um pedido de notificação} other {# pedidos de notificação}}. Não será fácil voltares a {count, plural, one {acederes-lhe} other {aceder-lhes}}. Tens a certeza de que pretendes continuar?",
  "notification_requests.confirm_dismiss_multiple.title": "Rejeitar pedidos de notificação?",
  "notification_requests.dismiss": "Descartar",
  "notification_requests.dismiss_multiple": "{count, plural, one {Rejeitar # pedido…} other {Rejeitar # pedidos…}}",
  "notification_requests.edit_selection": "Editar",
  "notification_requests.exit_selection": "Concluído",
  "notification_requests.explainer_for_limited_account": "As notificações desta conta foram filtradas porque a conta foi limitada por um moderador.",
  "notification_requests.explainer_for_limited_remote_account": "As notificações desta conta foram filtradas porque a conta ou o servidor desta foram limitados por um moderador.",
  "notification_requests.maximize": "Maximizar",
  "notification_requests.minimize_banner": "Minimizar o cabeçalho das notificações filtradas",
  "notification_requests.notifications_from": "Notificações de {name}",
  "notification_requests.title": "Notificações filtradas",
  "notification_requests.view": "Ver notificações",
  "notifications.clear": "Limpar notificações",
  "notifications.clear_confirmation": "Queres mesmo limpar todas as notificações?",
  "notifications.clear_title": "Limpar notificações?",
  "notifications.column_settings.admin.report": "Novas denúncias:",
  "notifications.column_settings.admin.sign_up": "Novas inscrições:",
  "notifications.column_settings.alert": "Notificações desktop",
  "notifications.column_settings.favourite": "Favoritos:",
  "notifications.column_settings.filter_bar.advanced": "Mostrar todas as categorias",
  "notifications.column_settings.filter_bar.category": "Barra de filtros rápidos",
  "notifications.column_settings.follow": "Novos seguidores:",
  "notifications.column_settings.follow_request": "Novos pedidos para seguir:",
  "notifications.column_settings.mention": "Menções:",
  "notifications.column_settings.poll": "Resultados da sondagem:",
  "notifications.column_settings.push": "Notificações \"push\"",
  "notifications.column_settings.quote": "Citações:",
  "notifications.column_settings.reblog": "Partilhas:",
  "notifications.column_settings.show": "Mostrar na coluna",
  "notifications.column_settings.sound": "Reproduzir som",
  "notifications.column_settings.status": "Novas publicações:",
  "notifications.column_settings.unread_notifications.category": "Notificações não lidas",
  "notifications.column_settings.unread_notifications.highlight": "Destacar notificações não lidas",
  "notifications.column_settings.update": "Edições:",
  "notifications.filter.all": "Todas",
  "notifications.filter.boosts": "Re-publicações",
  "notifications.filter.favourites": "Favoritos",
  "notifications.filter.follows": "Seguidores",
  "notifications.filter.mentions": "Menções",
  "notifications.filter.polls": "Votações",
  "notifications.filter.statuses": "Atualizações das contas que segues",
  "notifications.grant_permission": "Dar autorização.",
  "notifications.group": "{count} notificações",
  "notifications.mark_as_read": "Marcar todas as notificações como lidas",
  "notifications.permission_denied": "As notificações desktop não estão disponíveis porque a autorização, solicitada pelo navegador, foi recusada antes",
  "notifications.permission_denied_alert": "As notificações desktop não podem ser activadas, uma vez que a autorização do navegador foi recusada antes",
  "notifications.permission_required": "As notificações desktop não estão disponíveis porque a autorização necessária não foi concedida.",
  "notifications.policy.filter_new_accounts.hint": "Criada nos últimos {days, plural, one {um dia} other {# dias}}",
  "notifications.policy.filter_new_accounts_title": "Novas contas",
  "notifications.policy.filter_not_followers_hint": "Incluindo pessoas que te seguem há menos de {days, plural, one {um dia} other {# dias}}",
  "notifications.policy.filter_not_followers_title": "Pessoas que não te seguem",
  "notifications.policy.filter_not_following_hint": "Até que os aproves manualmente",
  "notifications.policy.filter_not_following_title": "Pessoas que não segues",
  "notifications.policy.filter_private_mentions_hint": "Filtrado, a não ser que seja em resposta à tua própria menção ou se seguires o remetente",
  "notifications.policy.filter_private_mentions_title": "Menções privadas não solicitadas",
  "notifications.policy.title": "Gerir notificações de…",
  "notifications_permission_banner.enable": "Ativar notificações no ambiente de trabalho",
  "notifications_permission_banner.how_to_control": "Para receber notificações enquanto não tens a Ciberlândia aberta, activa as notificações desktop. É possível controlar ao certo os tipos de interações que geram notificações, através do botão {icon} acima.",
  "notifications_permission_banner.title": "Nunca percas nada",
  "onboarding.follows.lead": "Você personaliza a sua própria página inicial. Quanto mais pessoas seguir, mais ativa e interessante ela será. Estes perfis podem ser um bom ponto de partida - pode sempre deixar de os seguir mais tarde!",
  "onboarding.follows.back": "Voltar",
  "onboarding.follows.empty": "Infelizmente não é possível mostrar resultados neste momento. Podes tentar pesquisar ou navegar na página \"Explorar\" para encontrares pessoas para seguires ou tentar novamente mais tarde.",
  "onboarding.follows.next": "A seguir: configura o teu perfil",
  "onboarding.follows.search": "Pesquisar",
  "onboarding.follows.title": "Popular no Mastodon",
  "onboarding.profile.discoverable": "Permitir que o meu perfil seja descoberto",
  "onboarding.profile.discoverable_hint": "Quando opta pela possibilidade de ser descoberto no Mastodon, as suas mensagens podem aparecer nos resultados de pesquisa e nos destaques, e o seu perfil pode ser sugerido a pessoas com interesses semelhantes aos seus.",
  "onboarding.profile.display_name": "Nome a apresentar",
  "onboarding.profile.display_name_hint": "O teu nome completo ou o teu nome divertido…",
  "onboarding.profile.finish": "Terminar",
  "onboarding.profile.note": "Biografia",
  "onboarding.profile.note_hint": "Podes @mencionar outras pessoas e usar #etiquetas…",
  "onboarding.profile.title": "Configuração do perfil",
  "onboarding.profile.upload_avatar": "Enviar foto de perfil",
  "onboarding.profile.upload_header": "Enviar cabeçalho do perfil",
  "password_confirmation.exceeds_maxlength": "A confirmação da palavra-passe excedeu o tamanho máximo ",
  "password_confirmation.mismatching": "A confirmação da palavra-passe não corresponde",
  "picture_in_picture.restore": "Repôr",
  "poll.closed": "Fechada",
  "poll.refresh": "Re-carregar",
  "poll.reveal": "Ver resultados",
  "poll.total_people": "{count, plural, one {# pessoa} other {# pessoas}}",
  "poll.total_votes": "{count, plural, one {# voto} other {# votos}}",
  "poll.vote": "Votar",
  "poll.voted": "Votaste nesta resposta",
  "poll.votes": "{votes, plural, one {# voto } other {# votos}}",
  "poll_button.add_poll": "Criar sondagem",
  "poll_button.remove_poll": "Retirar sondagem",
  "privacy.change": "Ajustar a privacidade da publicação",
  "privacy.direct.long": "Apenas para utilizadores mencionados",
  "privacy.direct.short": "Apenas contas mencionadas",
  "privacy.private.long": "Apenas para os teus seguidores",
  "privacy.private.short": "Apenas seguidores",
  "privacy.public.long": "Visível para todos",
  "privacy.public.short": "Público",
  "privacy.quote.anyone": "{visibility}, citações permitidas",
  "privacy.quote.disabled": "{visibility}, citações desativadas",
  "privacy.quote.limited": "{visibility}, citações limitadas",
  "privacy.unlisted.additional": "Este comportamento é exatamente igual ao do público, exceto que a publicação não aparecerá em cronologias, nas etiquetas, ao explorar ou na pesquisa do Mastodon, mesmo que tenhas optado por participar em toda a tua conta.",
  "privacy.unlisted.long": "Oculto dos resultados de pesquisa, destaques e cronologias públicas do Mastodon",
  "privacy.unlisted.short": "Público silencioso",
  "privacy_policy.last_updated": "Última atualização em {date}",
  "privacy_policy.title": "Política de privacidade",
  "quote_error.edit": "Não é possível adicionar citações ao editar uma publicação.",
  "quote_error.poll": "Não é permitido citar sondagens.",
  "quote_error.private_mentions": "A citação não é permitida em menções privadas.",
  "quote_error.quote": "Apenas é permitida uma citação de cada vez.",
  "quote_error.unauthorized": "Não está autorizado a citar esta publicação.",
  "quote_error.upload": "Não é permitida a citação com anexos multimédia.",
  "recommended": "Recomendado",
  "refresh": "Atualizar",
  "regeneration_indicator.please_stand_by": "Aguarda um momento.",
  "regeneration_indicator.preparing_your_home_feed": "A preparar a cronologia na tua página inicial…",
  "relative_time.days": "{number}d",
  "relative_time.full.days": "{number, plural,one {# dia} other {# dias}} atrás",
  "relative_time.full.hours": "{number, plural,one {# hora}other {# horas}} atrás",
  "relative_time.full.just_now": "agora mesmo",
  "relative_time.full.minutes": "{number, plural,one {# minuto}other {# minutos}} atrás",
  "relative_time.full.seconds": "{number, plural,one {# segundo} other {# segundos}} atrás",
  "relative_time.hours": "{number}h",
  "relative_time.just_now": "agora",
  "relative_time.minutes": "{number}m",
  "relative_time.seconds": "{number}s",
  "relative_time.today": "hoje",
  "remove_quote_hint.button_label": "Entendido",
  "remove_quote_hint.message": "Pode fazê-lo a partir do {icon} menu de opções.",
  "remove_quote_hint.title": "Queres remover a tua publicação citada?",
  "reply_indicator.attachments": "{count, plural, one {# anexo} other {# anexos}}",
  "reply_indicator.cancel": "Cancelar",
  "reply_indicator.poll": "Sondagem",
  "report.block": "Bloquear",
  "report.block_explanation": "Não vais ver mais as publicações desta conta. Ela não vai poder seguir-te ou ver as tuas publicações. Essa conta vai ser notificada que está bloqueada.",
  "report.categories.legal": "Legal",
  "report.categories.other": "Outro",
  "report.categories.spam": "Spam",
  "report.categories.violation": "O conteúdo viola uma ou mais regras do servidor",
  "report.category.subtitle": "Escolhe o mais adequado",
  "report.close": "Concluído",
  "report.comment.title": "Há mais alguma coisa que devamos saber?",
  "report.forward": "Reencaminhar para {target}",
  "report.forward_hint": "A conta é de outro servidor. Enviar uma cópia anónima da denúncia para lá também?",
  "report.mute": "Ocultar",
  "report.mute_explanation": "Não vais ver mais as publicações desta conta. Ela ainda pode seguir-te e ver as tuas publicações, e não vai saber que está silenciada.",
  "report.next": "Seguinte",
  "report.placeholder": "Mais comentários",
  "report.reasons.dislike": "Não gosto disto",
  "report.reasons.dislike_description": "Não é algo que eu queira ver",
  "report.reasons.legal": "É ilegal",
  "report.reasons.legal_description": "Acreditas que isto viola a lei do teu país ou do país do servidor",
  "report.reasons.other": "É outra coisa",
  "report.reasons.other_description": "O problema não encaixa nas outras categorias",
  "report.reasons.spam": "É spam",
  "report.reasons.spam_description": "Links maliciosos, contactos falsos, ou respostas repetitivas",
  "report.reasons.violation": "Vai contra as regras do servidor",
  "report.reasons.violation_description": "Tudo o que vá contra regras específicas",
  "report.rules.subtitle": "Selecciona tudo o que se aplicar",
  "report.rules.title": "Que regras estão a ser violadas?",
  "report.statuses.subtitle": "Selecciona tudo o que se aplicar",
  "report.statuses.title": "Existe alguma publicação que sustente esta denúncia?",
  "report.submission_error": "A denúncia não pôde ser enviada",
  "report.submission_error_details": "Por favor, verifica a tua ligação à rede e tenta novamente mais tarde.",
  "report.submit": "Enviar",
  "report.target": "A denunciar {target}",
  "report.thanks.take_action": "Estas são as tuas opções para controlar o que vês na Ciberlândia:",
  "report.thanks.take_action_actionable": "Enquanto revemos a tua denúncia, podes tomar medidas contra @{name}:",
  "report.thanks.title": "Não queres ver isto?",
  "report.thanks.title_actionable": "Obrigado pela tua denúncia, vamos tratar o assunto com todo o cuidado e seriedade.",
  "report.unfollow": "Deixar de seguir @{name}",
  "report.unfollow_explanation": "Estás a seguir esta conta. Para não veres mais as publicações desta conta na tua página inicial, deixa de segui-la.",
  "report_notification.attached_statuses": "{count, plural,one {{count} publicação} other {{count} publicações}} em anexo",
  "report_notification.categories.legal": "Legal",
  "report_notification.categories.legal_sentence": "conteúdo ilegal",
  "report_notification.categories.other": "Outro",
  "report_notification.categories.other_sentence": "outro",
  "report_notification.categories.spam": "Spam",
  "report_notification.categories.spam_sentence": "publicidade indesejada / spam",
  "report_notification.categories.violation": "Violação de regra",
  "report_notification.categories.violation_sentence": "violação de regra",
  "report_notification.open": "Abrir denúncia",
  "search.clear": "Limpar pesquisa",
  "search.no_recent_searches": "Nenhuma pesquisa recente",
  "search.placeholder": "Pesquisar",
  "search.quick_action.account_search": "Perfis com correspondência a {x}",
  "search.quick_action.go_to_account": "Ir para o perfil {x}",
  "search.quick_action.go_to_hashtag": "Ir para a etiqueta {x}",
  "search.quick_action.open_url": "Abrir ligação no Mastodon",
  "search.quick_action.status_search": "Publicações com correspondência a {x}",
  "search.search_or_paste": "Pesquisar...",
  "search_popout.full_text_search_disabled_message": "Não disponível em {domain}.",
  "search_popout.full_text_search_logged_out_message": "Apenas disponível com sessão iniciada.",
  "search_popout.language_code": "Código ISO do idioma",
  "search_popout.options": "Opções de pesquisa",
  "search_popout.quick_actions": "Acções rápidas",
  "search_popout.recent": "Pesquisas recentes",
  "search_popout.specific_date": "data específica",
  "search_popout.search_format": "Formato avançado de pesquisa",
  "search_popout.search_or_paste": "Pesquisar...",
  "search_popout.tips.full_text": "Texto completo devolve publicações que escreveste, marcaste como favorita, partilhaste ou que te mencionou, tal como nomes de utilizador, alcunhas e hashtags.",
  "search_popout.tips.hashtag": "hashtag",
  "search_popout.tips.status": "publicação",
  "search_popout.tips.text": "Podes pesquisar por nomes, contas e hashtags.",
  "search_popout.tips.user": "utilizador",
  "search_popout.user": "utilizador",
  "search_results.accounts": "Pessoas",
  "search_results.all": "Tudo",
  "search_results.hashtags": "Hashtags",
  "search_results.nothing_found": "Não conseguimos encontrar resultados para as expressões indicadas",
  "search_results.see_all": "Ver tudo",
  "search_results.statuses": "Toots",
  "search_results.statuses_fts_disabled": "A pesquisa de publicações pelo seu conteúdo não está disponível na Ciberlândia.",
  "search_results.title": "Pesquisar por {q}",
  "search_results.total": "{count, number} {count, plural, one {resultado} other {resultados}}",
  "server_banner.about_active_users": "Pessoas que utilizaram este servidor nos últimos 30 dias (Utilizadores Ativos Mensais)",
  "server_banner.active_users": "utilizadores activos",
  "server_banner.administered_by": "Administrado por:",
  "server_banner.is_one_of_many": "{domain} é um dos muitos servidores Mastodon independentes que podes utilizar para participar no fediverso.",
  "server_banner.server_stats": "Estatísticas do servidor:",
  "sign_in_banner.create_account": "Criar uma conta",
  "sign_in_banner.follow_anyone": "Siga alguém no fediverso e veja tudo em ordem cronológica. Sem algoritmos, anúncios ou clickbait à vista.",
  "sign_in_banner.mastodon_is": "O Mastodon é a melhor maneira de acompanhar o que está a acontecer.",
  "sign_in_banner.sign_in": "Iniciar sessão",
  "sign_in_banner.sso_redirect": "Inicia a sessão ou cria uma conta",
  "skip_links.hotkey": "<span>Tecla de atalho</span> {hotkey}",
  "skip_links.skip_to_content": "Ir para o conteúdo principal",
  "skip_links.skip_to_navigation": "Ir para a navegação principal",
  "status.admin_account": "Abrir a interface de moderação para @{name}",
  "status.admin_domain": "Abrir interface de moderação para {domain}",
  "status.admin_status": "Abrir esta publicação na interface de moderação",
  "status.all_disabled": "Partilhas e citações estão desativados",
  "status.block": "Bloquear @{name}",
  "status.bookmark": "Guardar nos marcadores",
  "status.cancel_reblog_private": "Deixar de partilhar",
  "status.cannot_quote": "Não lhe é permitido citar esta publicação",
  "status.cannot_reblog": "Esta publicação não pode ser partilhada",
  "status.contains_quote": "Contém citação",
  "status.context.loading": "A carregar mais respostas",
  "status.context.loading_error": "Não foi possível carregar novas respostas",
  "status.context.loading_success": "Novas respostas carregadas",
  "status.context.more_replies_found": "Foram encontradas mais respostas",
  "status.context.retry": "Repetir",
  "status.context.show": "Mostrar",
  "status.continued_thread": "Continuação da conversa",
  "status.copy": "Copiar hiperligação da publicação",
  "status.delete": "Eliminar",
  "status.delete.success": "Publicação eliminada",
  "status.detailed_status": "Vista pormenorizada da conversa",
  "status.direct": "Mencionar @{name} em privado",
  "status.direct_indicator": "Menção privada",
  "status.edit": "Editar",
  "status.edited": "Última edição em {date}",
  "status.edited_x_times": "Editado {count, plural,one {{count} vez} other {{count} vezes}}",
  "status.embed": "Embed",
  "status.favourite": "Adicionar aos favoritos",
  "status.favourites_count": "{count, plural, one {{counter} favorito} other {{counter} favoritos}}",
  "status.filter": "Filtrar esta publicação",
  "status.filtered": "Filtrada",
  "status.hide": "Ocultar publicação",
  "status.history.created": "{name} criada em {date}",
  "status.history.edited": "{name} editada em {date}",
  "status.load_more": "Carregar mais",
  "status.media.open": "Clicar para abrir",
  "status.media.show": "Clicar para ver",
  "status.media_hidden": "Media oculta",
  "status.mention": "Mencionar @{name}",
  "status.more": "Mais",
  "status.mute": "Ocultar @{name}",
  "status.mute_conversation": "Ocultar conversa",
  "status.open": "Expandir esta publicação",
  "status.pin": "Afixar no perfil",
  "status.quote": "Citação",
  "status.quote.cancel": "Cancelar citação",
  "status.quote_error.blocked_account_hint.title": "Esta publicação está oculta porque bloqueou @{name}.",
  "status.quote_error.blocked_domain_hint.title": "Esta publicação está oculta porque bloqueou {domain}.",
  "status.quote_error.filtered": "Oculto devido a um dos seus filtros",
  "status.quote_error.limited_account_hint.action": "Mostrar na mesma",
  "status.quote_error.limited_account_hint.title": "Esta conta foi ocultada pelos moderadores de {domain}.",
  "status.quote_error.muted_account_hint.title": "Esta publicação está oculta porque silenciou @{name}.",
  "status.quote_error.not_available": "Publicação indisponível",
  "status.quote_error.pending_approval": "Publicação pendente",
  "status.quote_error.pending_approval_popout.body": "No Mastodon, pode controlar se alguém pode citar as suas publicações. Esta publicação está pendente enquanto aguardamos a aprovação do autor original.",
  "status.quote_error.revoked": "Publicação removida pelo autor",
  "status.quote_followers_only": "Apenas seguidores podem citar esta publicação",
  "status.quote_manual_review": "O autor vai proceder a uma revisão manual",
  "status.quote_noun": "Citação",
  "status.quote_policy_change": "Alterar quem pode citar",
  "status.quote_post_author": "Citou uma publicação de @{name}",
  "status.quote_private": "Publicações privadas não podem ser citadas",
  "status.quotes.empty": "Ainda ninguém citou esta publicação. Quando alguém o fizer, aparecerá aqui.",
  "status.quotes.local_other_disclaimer": "As citações rejeitadas pelo autor não serão exibidas.",
  "status.quotes.remote_other_disclaimer": "Apenas citações de {domain} serão garantidamente exibidas aqui. Citações rejeitadas pelo autor não serão exibidas.",
  "status.quotes_count": "{count, plural, one {{counter} citação} other {{counter} citações}}",
  "status.read_more": "Ler mais",
  "status.reblog": "Impulsionar",
  "status.reblog_or_quote": "Partilha ou cita",
  "status.reblog_private": "Partilha novamente com os teus seguidores",
  "status.reblogged_by": "{name} impulsionou",
  "status.reblogs.empty": "Ainda ninguém partilhou esta publicação. Quando alguém o fizer, aparecerá aqui.",
  "status.reblogs_count": "{count, plural, one {{counter} partilha} other {{counter} partilhas}}",
  "status.redraft": "Eliminar e reescrever",
  "status.remove_bookmark": "Remover marcador",
  "status.remove_favourite": "Remover dos favoritos",
  "status.remove_quote": "Remover",
  "status.replied_in_thread": "Responder na conversa",
  "status.replied_to": "Respondeu a {name}",
  "status.reply": "Responder",
  "status.replyAll": "Responder à conversa",
  "status.report": "Denunciar @{name}",
  "status.request_quote": "Pedir para citar",
  "status.revoke_quote": "Remover a minha publicação da publicação de @{name}",
  "status.sensitive_warning": "Conteúdo sensível",
  "status.share": "Partilhar",
  "status.show_less_all": "Ocultar conteúdo sensível em todas",
  "status.show_more_all": "Mostrar conteúdo sensível em todas",
  "status.show_original": "Mostrar original",
  "status.title.with_attachments": "{user} publicou {attachmentCount, plural,one {um anexo} other {{attachmentCount} anexos}}",
  "status.translate": "Traduzir",
  "status.translated_from_with": "Traduzido do {lang} usando {provider}",
  "status.uncached_media_warning": "Pré-visualização não disponível",
  "status.unmute_conversation": "Deixar de ocultar esta conversa",
  "status.unpin": "Desafixar do perfil",
  "subscribed_languages.lead": "Após a alteração, apenas as publicações nos idiomas selecionados aparecerão na cronologia da tua página inicial e das tuas listas. Não seleciones nenhum idioma para receberes publicações em todos os idiomas.",
  "subscribed_languages.save": "Guardar alterações",
  "subscribed_languages.target": "Alterar idiomas subscritos para {target}",
  "tabs_bar.home": "Início",
  "tabs_bar.menu": "Menu",
  "tabs_bar.notifications": "Notificações",
  "tabs_bar.publish": "Nova publicação",
  "tabs_bar.search": "Pesquisar",
  "tag.remove": "Remover",
  "terms_of_service.effective_as_of": "Válido a partir de {date}",
  "terms_of_service.title": "Termos do serviço",
  "terms_of_service.upcoming_changes_on": "Próximas aterações em {date}",
  "time_remaining.days": "{number, plural, one {# dia restante} other {# dias restantes}}",
  "time_remaining.hours": "{number, plural, one {# hora restante} other {# horas restantes}}",
  "time_remaining.minutes": "{number, plural, one {# minuto restante} other {# minutos restantes}}",
  "time_remaining.moments": "Momentos restantes",
  "time_remaining.seconds": "{número, plural, um {# second} outro {# seconds}} faltam",
  "timeline_hint.remote_resource_not_displayed": "{resource} de outros servidores não são mostradas.",
  "timeline_hint.resources.followers": "Seguidores",
  "timeline_hint.resources.follows": "A seguir",
  "timeline_hint.resources.statuses": "Publicações antigas",
  "trends.counter_by_accounts": "{count, plural, one {{counter} pessoa} other {{counter} pessoas}} {days, plural, one {no último dia} other {nos últimos {days} dias}}",
  "trends.trending_now": "O que está a dar",
  "ui.beforeunload": "O teu rascunho vai ser perdido se saíres da Ciberlândia.",
  "units.short.billion": "{count}MM",
  "units.short.million": "{count}M",
  "units.short.thousand": "{count}m",
  "upload_area.title": "Arrastar e largar para enviar",
  "upload_button.label": "Adicionar imagens, um vídeo ou um ficheiro de som",
  "upload_error.limit": "Limite de envio de ficheiros excedido.",
  "upload_error.poll": "Não é permitido o envio de ficheiros em sondagens.",
  "upload_error.quote": "Carregamento de ficheiros não é permitido com citações.",
  "upload_form.drag_and_drop.instructions": "Para escolher um anexo multimédia, prima espaço ou enter. Enquanto arrasta, utilize as teclas de setas para mover o anexo multimédia em qualquer direção. Prima espaço ou enter novamente para largar o anexo multimédia na sua nova posição ou prima escape para cancelar.",
  "upload_form.drag_and_drop.on_drag_cancel": "O arrastamento foi cancelado. O anexo multimédia {item} foi descartado.",
  "upload_form.drag_and_drop.on_drag_end": "O anexo multimédia {item} foi descartado.",
  "upload_form.drag_and_drop.on_drag_over": "O anexo multimédia {item} foi movido.",
  "upload_form.drag_and_drop.on_drag_start": "O anexo multimédia {item} foi escolhido.",
  "upload_form.edit": "Editar",
  "upload_form.thumbnail": "Alterar miniatura",
  "upload_form.undo": "Eliminar",
  "upload_form.video_description": "Descreve para pessoas com dificuldades auditivas ou visuais",
  "upload_modal.analyzing_picture": "A analisar imagem…",
  "upload_modal.apply": "Aplicar",
  "upload_modal.applying": "A aplicar…",
  "upload_modal.choose_image": "Escolher imagem",
  "upload_modal.description_placeholder": "Grave e cabisbaixo, o filho justo zelava pela querida mãe doente",
  "upload_modal.detect_text": "Detectar texto na imagem",
  "upload_modal.edit_media": "Editar media",
  "upload_modal.hint": "Clica ou arrasta o círculo na pré-visualização para escolher o ponto focal que será sempre visível em todas as miniaturas.",
  "upload_modal.preparing_ocr": "A preparar OCR…",
  "upload_modal.preview_label": "Pré-visualizar ({ratio})",
  "upload_progress.label": "A enviar...",
  "upload_progress.processing": "A processar…",
  "username.taken": "Esse nome de utilizador já está a ser utilizado. Por favor, tente outro",
  "video.close": "Fechar vídeo",
  "video.download": "Descarregar ficheiro",
  "video.exit_fullscreen": "Sair do ecrã completo",
  "video.expand": "Expandir vídeo",
  "video.fullscreen": "Ecrã completo",
  "video.hide": "Ocultar vídeo",
  "video.mute": "Silenciar",
  "video.pause": "Pausar",
  "video.play": "Reproduzir",
  "video.skip_backward": "Saltar para trás",
  "video.skip_forward": "Saltar para a frente",
  "video.unmute": "Ativar som",
  "video.volume_down": "Diminuir volume",
  "video.volume_up": "Aumentar volume",
  "visibility_modal.button_title": "Definir visibilidade",
  "visibility_modal.direct_quote_warning.text": "Se guardar as definições atuais, a citação incorporada será convertida numa hiperligação.",
  "visibility_modal.direct_quote_warning.title": "Citações não podem ser incorporadas em menções privadas",
  "visibility_modal.header": "Visibilidade e interação",
  "visibility_modal.helper.direct_quoting": "As menções privadas criadas no Mastodon não podem ser citadas por outras pessoas.",
  "visibility_modal.helper.privacy_editing": "A visibilidade não pode ser alterada após a publicação ser publicada.",
  "visibility_modal.helper.privacy_private_self_quote": "As autocitações de publicações privadas não podem ser tornadas públicas.",
  "visibility_modal.helper.private_quoting": "As publicações apenas para seguidores criadas no Mastodon não podem ser citadas por outras pessoas.",
  "visibility_modal.helper.unlisted_quoting": "Quando as pessoas o citarem, as respetivas publicações também serão ocultadas dos destaques.",
  "visibility_modal.instructions": "Controle quem pode interagir com esta publicação. Também pode definir esta configuração para todas as publicações futuras, em <link>Preferências > Padrões de publicação</link>.",
  "visibility_modal.privacy_label": "Visibilidade",
  "visibility_modal.quote_followers": "Apenas seguidores",
  "visibility_modal.quote_label": "Quem pode citar",
  "visibility_modal.quote_nobody": "Apenas eu",
  "visibility_modal.quote_public": "Todos",
  "visibility_modal.save": "Guardar"
}
